export default function CatalogListSection({ children, pagination }) {
	return (
		<div className="flex w-full flex-col">
			{children}
			{pagination ? (
				<div className="flex justify-center pt-8 pb-2">{pagination}</div>
			) : null}
		</div>
	);
}
